import { useEmployee } from "@/api/Employee";
import { deducedError } from "@/Utils/ErrorUtils";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Loading } from "@medoma/components/Loading/Loading";
import { Text, type IText } from "@medoma/components/Text/Text";
import * as Sentry from "@sentry/react";
import { CompetenceChip } from "@/components/Chips/CompetenceChip";
import styles from "./EmployeeName.module.scss";
import { employeeName } from "@medoma/models/shifts";
import { useLingui } from "@lingui/react/macro";

const EmployeeName = ({
  employeeId,
  showCompetence,
  size = "base",
}: {
  employeeId: number;
  showCompetence: boolean;
  size?: IText["size"];
}) => {
  const { t } = useLingui();
  const { data: employee, isPending, isError, error } = useEmployee(employeeId);

  if (isPending) {
    return <Loading message={t`Hämtar medarbetare`} />;
  }

  if (isError) {
    Sentry.captureException(error);
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta medarbetare`} ${deducedError(error)}`}
      />
    );
  }

  return (
    <div className={styles.employeeName}>
      <Text element="span" size={size}>
        {employeeName(employee, { employeeNameFormat: "full" })}
      </Text>
      {showCompetence && employee.competence !== null ? (
        <CompetenceChip
          competence={employee.competence}
          state="neutral"
          size={size === "small" ? "tiny" : "small"}
        />
      ) : null}
    </div>
  );
};

export default EmployeeName;
